<template>
  <div
    :class="['MouseSeleted', props.class]"
    @mousedown="mouseDown"
    @mouseup="mouseUp"
    @mousemove="mouseMove"
  >
    <div class="seleted-area" v-if="canShowDiv()" :style="getStyle().style"></div>
    <slot></slot>
  </div>
</template>

<script setup>
import { ref, defineProps, onBeforeUnmount } from 'vue';
import './index.scss';
import EventBus from '@/controller/EventBus';
import { MouseStatus } from './config';

const props = defineProps({
  isDocument: Boolean,
  scrollRef: Object,
  class: String,
  canUse: {
    type: Boolean,
    default: true,
  },
  keyType: String, // 拖拽的key标记，区分是文件区域还是文件夹区域
});
const showSeleted = ref(MouseStatus.Init); // 0默认和（含鼠标抬起），1鼠标按下，2鼠标移动
const initPos = {
  startX: 0,
  startY: 0,
  endX: 0,
  endY: 0,
  startTopScroll: 0,
  startLeftScroll: 0,
  endTopScroll: 0,
  endLeftScroll: 0,
};
const pos = ref({ ...initPos });
function getScrollPos() {
  const scrollEle = props.scrollRef || document.documentElement || document.body;
  return {
    top: scrollEle.scrollTop || 0,
    left: scrollEle.scrollLeft || 0,
  };
}
function canShowDiv() {
  return showSeleted.value === MouseStatus.Move;
}
function getOffset() {
  let offset = {
    topOffset: 0,
    leftOffset: 0,
  };
  if (props.scrollRef) {
    const ele = props.scrollRef.getBoundingClientRect();
    offset = {
      topOffset: ele.top,
      leftOffset: ele.left,
    };
  }
  return offset;
}
function getStyle() {
  if (!canShowDiv()) {
    return {};
  }
  const { topOffset, leftOffset } = getOffset();
  const {
    startX,
    startY,
    endX,
    endY,
    startTopScroll,
    startLeftScroll,
    endTopScroll,
    endLeftScroll,
  } = pos.value;
  const width = endX - startX + endLeftScroll - startLeftScroll;
  const height = endY - startY + endTopScroll - startTopScroll;
  const left =
    width > 0 ? startX + startLeftScroll - leftOffset : endX + endLeftScroll - leftOffset;
  const top = height > 0 ? startY + startTopScroll - topOffset : endY + endTopScroll - topOffset;
  const style = {
    // Math.abs  top：clientY+scrollTop-顶部的160，left同理 //height:当下top-原来top
    width: `${Math.abs(width)}px`,
    height: `${Math.abs(height)}px`,
    left: `${left}px`,
    top: `${top}px`,
  };
  return {
    style,
    pos: {
      width,
      left,
      top,
      height,
    },
  };
}
function canExec(event) {
  // 触发事件的元素是绑定事件的元素才做后续的事件处理
  return event.target === event.currentTarget;
}
function getSelectedPos(event) {
  const { top, left } = getScrollPos() || {};
  const { topOffset, leftOffset } = getOffset() || {};
  pos.value = {
    ...pos.value,
    endX: event.clientX,
    endY: event.clientY,
    endTopScroll: top,
    endLeftScroll: left,
  };
  return {
    keyType: props.keyType,
    pos: { ...pos.value },
    offset: {
      topOffset,
      leftOffset,
    },
    calc: getStyle().pos || {},
    scroll: getScrollPos() || {},
  };
}
function mouseDown(event) {
  if (!canExec(event) || !props.canUse) {
    return;
  }
  EventBus.mouseSelected.execEvent('mouseDown', { keyType: props.keyType });
  getOffset();
  const { top, left } = getScrollPos();
  showSeleted.value = MouseStatus.Down;
  pos.value = {
    ...pos.value,
    startX: event.clientX,
    startY: event.clientY,
    startTopScroll: top,
    startLeftScroll: left,
  };
}
function mouseUp(event) {
  showSeleted.value = MouseStatus.Init;
  pos.value = {
    ...initPos,
    endX: event.clientX,
    endY: event.clientX,
  };
}

function mouseMove(event) {
  if (showSeleted.value !== MouseStatus.Down && showSeleted.value !== MouseStatus.Move) {
    return;
  }
  showSeleted.value = MouseStatus.Move;

  EventBus.mouseSelected.execEvent('mouseSelected', getSelectedPos(event));
}
document.addEventListener('mouseup', mouseUp);
document.addEventListener('mousewheel', mouseMove);

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', mouseUp);
  document.removeEventListener('mousewheel', mouseMove);
});
</script>
